var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountseen = function SvgAccountseen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11 18.502H9.534a1 1 0 0 1-.832-.445l-.406-.61a1.002 1.002 0 0 0-.834-.445H3.997a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2.002H11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.504 21.004H15a.5.5 0 0 1-.5-.5v-.407a2.1 2.1 0 0 1 2.095-2.094h3.313a2.1 2.1 0 0 1 2.095 2.094v.406a.5.5 0 0 1-.5.5M18.253 15.502a2 2 0 1 1 .008 0z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.003 8.999V6.998a2 2 0 0 0-2-2H5.996a2 2 0 0 0-2 2v10.004"
  })));
};
export { SvgAccountseen as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTgwZDk1MWZiZmU0YzFhODNhMTkwOWY0MDJiOGE3NjAuc3ZnIjs=";